import * as types from '../mutation-types'

// state
export const state = {
  HeimatStadt: ''
}

// mutations
export const mutations = {

  [types.SET_HEIMATSTADT_SUCCESS] (state, { standort }) {
    console.log('neue Heimatstadt....' + standort)
    state.HeimatStadt = standort
  }
}

// actions
export const actions = {
  setStadt ({ commit }, payload) {
    commit(types.SET_HEIMATSTADT_SUCCESS, { standort: payload })
  },
  loescheHeimatStadt ({ commit }) {
    commit(types.SET_HEIMATSTADT_SUCCESS, { standort: '' })
  }
}

// getters
export const getters = {

  fetchHeimatStadt: state => {
    return state.HeimatStadt
  }
  // fetchNeueNachrichten: state => {
  //   return state.neueposts
  // },

  // // betriebecalc: (state) => (betriebe) => {
  // //   let resultArray = []

  // // },
  // nachrichtenszahl: state => state.nachrichten.length
}
